module.exports = __webpack_public_path__ + "img/logo-512.ec2a496d.png";